import { Component, Input, Output, EventEmitter } from '@angular/core';

import { PaginationButtonsProps } from '@kite_aerolab/shared/components';

@Component({
  selector: 'kite-pagination-buttons',
  templateUrl: './pagination-buttons.component.html'
})
export class PaginationButtonsComponent {
  /**
   * PageCount
   */
  @Input() pageCount: PaginationButtonsProps['pageCount'];

  /**
  * activePage
  */
  @Input() activePage: PaginationButtonsProps['activePage']

  /**
   * ResultsPerPage
   */
  @Input() resultsPerPage: PaginationButtonsProps['resultsPerPage']

  @Output() 
  onPageChange = new EventEmitter()
  
  center : number;

  hasEllipsis: boolean;
  hasLeftEllipsis: boolean;
  hasRightEllipsis: boolean;

  buttonsArray: number[];
  handleNextPage () {
    this.onPageChange.emit(this.activePage === this.pageCount ? this.pageCount : this.activePage + 1)
    this.changeCenterNumber()
  }

  handlePreviousPage () {
    this.onPageChange.emit(this.activePage === 1 ? 1 : this.activePage - 1)
    this.changeCenterNumber()
  }
  
  ngAfterViewInit () {
    this.changeCenterNumber()
    this.addEllipsis()
    this.buttonsArray = Array.from({length: this.pageCount}, (_, i) => i + 1)
  }

  ngOnChanges () {
    this.changeCenterNumber()
    this.addEllipsis()

    this.buttonsArray = Array.from({length: this.pageCount}, (_, i) => i + 1)
  }

  addEllipsis () {
    this.hasEllipsis = this.pageCount > 5;
    this.hasLeftEllipsis = this.hasEllipsis && this.activePage >= 4
    
    this.hasRightEllipsis = this.hasEllipsis && this.activePage <= this.pageCount - 3;
  }

  changeCenterNumber () {
    if (this.activePage < 4) // we are near the 1st button
      this.center = 3
    else if (this.pageCount - this.activePage < 3) // we are near the last button
      this.center = this.pageCount - 2
    else
      this.center = this.activePage
  }

  handleClick (event: number) {
    this.onPageChange.emit(event)
    this.changeCenterNumber()
  }
}
